import type {
  InsertTagTypeWithOptionalGroupIdMutation,
  InsertTagTypeWithOptionalGroupIdMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): InsertTagTypeWithOptionalGroupIdMutation => {
  return {
    insert_tag_type_one: {
      __typename: 'tag_type',
      TagTypeId: trpcData.Id,
    },
  };
};

export const useInsertTagTypeWithOptionalGroupIdTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.tag.insert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.tag.pathKey(),
        });
      },
    }),
  });

  return {
    insertTagType: async (
      variables: InsertTagTypeWithOptionalGroupIdMutationVariables
    ): Promise<InsertTagTypeWithOptionalGroupIdMutation> => {
      const result = await mutation.mutateAsync({
        Name: variables.Name ?? '',
        Description: variables.Description ?? null,
        TagTypeGroupId: variables.TagTypeGroupId ?? null,
      });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
